import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    RestaurantMenu as RestaurantMenuIcon,
    Group as GroupIcon,
    ShoppingCart as ShoppingCartIcon,
    WarningAmber as WarningAmberIcon,
    CheckCircle as CheckCircleIcon,
    Assignment as AssignmentIcon,
    Apps as AppsIcon,
    EmojiPeople as EmojiPeopleIcon,
    ArrowRightAlt as ArrowRightAltIcon,
    DoneAll as DoneAllIcon,
    MonetizationOn as MonetizationOnIcon
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    導入：なぜ「食費分担」が重要なのか
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('methods')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    食費の分担方法とおすすめルール
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('merit')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    共同購入と個別購入のメリット・デメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    実際に起きたトラブル事例と防止策
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('apps')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    食費分担に役立つおすすめアプリ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('conclusion')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめと成功のポイント
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button 
                    variant="outlined" 
                    size="small" 
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}
            
            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    導入：なぜ「食費分担」が重要なのか
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            ルームシェアは、家賃や光熱費を抑えられるだけでなく、日々の生活を豊かにする素敵な選択肢です。<br />
                            しかし、<b>「食費の分担」</b>に関しては、多くのルームシェアで悩みやトラブルの種となりやすいもの。<br />
                            <br />
                            <Chip label="食費" color="primary" variant="outlined" sx={{ mr: 1 }} /><Chip label="分担ルール" color="primary" variant="outlined" sx={{ mr: 1 }} /><Chip label="トラブル防止" color="primary" variant="outlined" />
                            <br /><br />
                            この記事では、<b>食費分担の方法・ルール作りのコツ・実際のトラブル事例と解決策・アプリ活用術</b>まで、実践的なノウハウをわかりやすく解説します。
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: 1, mb: 2 }}>
                            
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            
            {/* 食費分担方法 */}
            <Box id="methods" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    食費の分担方法とおすすめルール
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    食費の分担方法には大きく分けて<b>「共同購入」</b>と<b>「個別購入」</b>があります。それぞれのスタイルや、実際にうまくいくためのルール設定のポイントを紹介します。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <RestaurantMenuIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    共同購入（シェア用）
                                </Typography>
                            </Box>
                            <List>
                                <ListItem>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="お米・調味料・牛乳など、みんなで使う食材や日用品をまとめて購入" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="購入費用は人数で割って均等に分担" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="冷蔵庫やパントリーに「共用」「個人」ラベルを貼ると便利" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ShoppingCartIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    個別購入（自分用）
                                </Typography>
                            </Box>
                            <List>
                                <ListItem>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="自分が食べる分だけを個別に購入" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="それぞれが自己管理するため、トラブルが起きにくい" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="冷蔵庫や棚に名前を書いて区別するのがコツ" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>
                        分担スタイルを選ぶ際のチェックポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><AssignmentIcon color="info" /></ListItemIcon>
                            <ListItemText primary="全員の食生活スタイル（自炊派・外食派・食事時間の違い）を確認" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AssignmentIcon color="info" /></ListItemIcon>
                            <ListItemText primary="「共用で買う食材」と「個人で買う食材」を明確に分ける" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AssignmentIcon color="info" /></ListItemIcon>
                            <ListItemText primary="月1回の精算日を決めるとスムーズ" />
                        </ListItem>
                    </List>
                </Box>
            </Box>
            
            {/* メリット・デメリット */}
            <Box id="merit" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    共同購入と個別購入のメリット・デメリット
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <GroupIcon sx={{ color: '#00796b', mr: 1 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                        共同購入のメリット
                                    </Typography>
                                </Box>
                                <List>
                                    <ListItem>
                                        <ListItemIcon><MonetizationOnIcon color="primary" /></ListItemIcon>
                                        <ListItemText primary="まとめ買いで節約＆買い物時間を短縮" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><DoneAllIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="調味料など「使いきれない」を防げる" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><EmojiPeopleIcon color="secondary" /></ListItemIcon>
                                        <ListItemText primary="食材シェアで料理の幅が広がる" />
                                    </ListItem>
                                </List>
                                <Divider sx={{ my: 1 }} />
                                <Typography variant="subtitle2" color="text.secondary">
                                    デメリット
                                </Typography>
                                <List>
                                    <ListItem>
                                        <ListItemIcon><WarningAmberIcon color="warning" /></ListItemIcon>
                                        <ListItemText primary="使いすぎ・使い過ぎないで不公平感が出やすい" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><WarningAmberIcon color="warning" /></ListItemIcon>
                                        <ListItemText primary="各自の好みやアレルギー対応が難しい" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <ShoppingCartIcon sx={{ color: '#1976d2', mr: 1 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                        個別購入のメリット
                                    </Typography>
                                </Box>
                                <List>
                                    <ListItem>
                                        <ListItemIcon><DoneAllIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="好きなものを好きなタイミングで買える" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><DoneAllIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="コスト管理が明確で不満が出にくい" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><DoneAllIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="食生活やアレルギー対応がしやすい" />
                                    </ListItem>
                                </List>
                                <Divider sx={{ my: 1 }} />
                                <Typography variant="subtitle2" color="text.secondary">
                                    デメリット
                                </Typography>
                                <List>
                                    <ListItem>
                                        <ListItemIcon><WarningAmberIcon color="warning" /></ListItemIcon>
                                        <ListItemText primary="冷蔵庫が個人の食品でぎゅうぎゅうになる" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><WarningAmberIcon color="warning" /></ListItemIcon>
                                        <ListItemText primary="割高になることもある" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3 }}>
                    <img
                        src="/images/blog/kitchen-labeling_roomshare-shokuhin-buntan-ideas.jpg"
                        alt="キッチンの冷蔵庫の棚にラベルシールで区分された食品が並んでいる様子。共用・個人用が色分けされ、整理整頓されていることでトラブル予防のイメージを伝える。"
                        style={{ width: '100%', borderRadius: 12, marginTop: 12, boxShadow: '0 2px 10px #eee' }}
                    />
                </Box>
            </Box>
            
            {/* トラブル事例 */}
            <Box id="trouble" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    実際に起きたトラブル事例と防止策
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        ルームシェア経験者から集めた、よくあるトラブル事例をご紹介します。<br />
                        トラブルを未然に防ぐためのポイントもあわせて解説します。
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={1} sx={{ p: 2, bgcolor: '#fffde7' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>トラブル事例（1）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <b>「共用で買った食材がいつの間にか減っている！」</b>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    誰がどれだけ使ったのか曖昧なまま、「自分ばかりが負担している」と感じて不満が発生。
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={1} sx={{ p: 2, bgcolor: '#fffde7' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>トラブル事例（2）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <b>「個人用の食材が勝手に食べられていた…」</b>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    名前を書いていなかったため、「共用」と勘違いされてしまいトラブルに発展。
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
                
                <Box sx={{ my: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        トラブルを防ぐための5つのポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="共用・個人の食材をはっきり区別しラベルを貼る" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="月1回の清算・使った人が記録する仕組みをつくる" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="「これは共用？個人？」と迷ったら必ず確認" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="最初に「食費ルール」を紙やアプリで明文化しておく" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="定期的にルームメイト同士で話し合いの時間を設ける" />
                        </ListItem>
                    </List>
                </Box>
                <Box sx={{ mt: 3 }}>
                    <img
                        src="/images/blog/roommate-meeting_roomshare-shokuhin-buntan-ideas.jpg"
                        alt="リビングのテーブルでルームメイトたちがメモやスマホを持ち寄り、和やかに食費ルールについて話し合っている様子。共用ノートやコーヒーカップ、リラックスした雰囲気が伝わる。"
                        style={{ width: '100%', borderRadius: 12, marginTop: 12, boxShadow: '0 2px 10px #eee' }}
                    />
                </Box>
            </Box>
            
            {/* アプリ紹介 */}
            <Box id="apps" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    食費分担に役立つおすすめアプリ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    アナログなノートやLINEグループでも管理できますが、最近は<b>家計簿アプリ・割り勘アプリ</b>がとても便利です。<br />
                    専用アプリを活用すれば、記録・精算・見える化が一気にラクに！
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <Card elevation={3} sx={{ minHeight: 250 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <AppsIcon color="primary" sx={{ mr: 1 }} />
                                    <Typography variant="subtitle1" fontWeight="bold">Splitwise</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    グループ内での割り勘や支払いの管理が簡単。<br />
                                    食費だけでなく、家賃や光熱費の精算にもおすすめ。
                                </Typography>
                                <Button
                                    href="https://www.splitwise.com/"
                                    target="_blank"
                                    rel="noopener"
                                    variant="outlined"
                                    size="small"
                                    endIcon={<ArrowRightAltIcon />}
                                    sx={{ mt: 1 }}
                                >
                                    公式サイト
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card elevation={3} sx={{ minHeight: 250 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <AppsIcon color="secondary" sx={{ mr: 1 }} />
                                    <Typography variant="subtitle1" fontWeight="bold">家計簿アプリ Zaim</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    レシート撮影で自動記録。<br />
                                    支出カテゴリを分けて管理でき、グループ共有機能も便利。
                                </Typography>
                                <Button
                                    href="https://zaim.net/"
                                    target="_blank"
                                    rel="noopener"
                                    variant="outlined"
                                    size="small"
                                    endIcon={<ArrowRightAltIcon />}
                                    sx={{ mt: 1 }}
                                >
                                    公式サイト
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card elevation={3} sx={{ minHeight: 250 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <AppsIcon color="success" sx={{ mr: 1 }} />
                                    <Typography variant="subtitle1" fontWeight="bold">LINEグループノート</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    手軽に会話しながら買い物リストや精算記録を共有。<br />
                                    アプリ不要で始めやすいのが魅力です。
                                </Typography>
                                <Button
                                    href="https://guide.line.me/ja/messaging/line-group-note.html"
                                    target="_blank"
                                    rel="noopener"
                                    variant="outlined"
                                    size="small"
                                    endIcon={<ArrowRightAltIcon />}
                                    sx={{ mt: 1 }}
                                >
                                    使い方ガイド
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
            
            {/* まとめ */}
            <Box id="conclusion" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめと成功のポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアにおける食費分担は、<b>「ルールの明確化」と「コミュニケーション」</b>が成功の鍵です。<br />
                    ひと手間かけて仕組みを作れば、<b>節約・時短・トラブル防止・食生活の充実</b>が叶います！
                </Typography>
                <Paper elevation={1} sx={{ p: 2, bgcolor: '#e3f2fd', borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        食費分担・成功のコツ
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="最初に分担ルールを紙やアプリで明文化する" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="定期的に話し合い、柔軟にルールを見直す" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="気になることがあればすぐに相談・共有する" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="食費アプリやノートで記録・可視化を習慣に" />
                        </ListItem>
                    </List>
                </Paper>
                <Box sx={{ mt: 3 }}>
                    <img
                        src="/images/blog/happy-share-cooking_roomshare-shokuhin-buntan-ideas.jpg"
                        alt="ナチュラルなキッチンでルームメイトたちが一緒に料理を作りながら笑顔でコミュニケーションしている様子。暖かい照明と楽しげな雰囲気が伝わる。"
                        style={{ width: '100%', borderRadius: 12, marginTop: 12, boxShadow: '0 2px 10px #eee' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-shokuhin-buntan-ideas',
    slug: 'roomshare-shokuhin-buntan-ideas',
    title: 'ルームシェアの「食費分担」アイデアとトラブル防止策',
    excerpt: '食費の分担方法、共同購入・個別購入のメリット、トラブル事例、おすすめアプリ紹介などルームシェアの食費分担で役立つ実践的なノウハウを解説します。',
    coverImage: '/images/blog/cover-roomshare-shokuhin-buntan_roomshare-shokuhin-buntan-ideas.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく食卓を囲み、会話をしている様子を温かい雰囲気で表現した写真',
    publishedAt: '2024-06-10T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '家計管理', '生活ノウハウ'],
    tags: ['食費分担', '共同購入', 'トラブル防止', 'アプリ活用', '家計管理'],
    author: {
        name: '佐藤 明子',
        avatar: '/images/avatars/akiko-sato.jpg',
        bio: 'ルームシェア相談歴10年。多数のルームシェア運営・アドバイス経験を通じて、実践的な暮らしの知恵やトラブル回避法を多数発信。',
        profilePicture: '/images/avatars/akiko-sato.jpg'
    },
    viewCount: 1240,
    contentComponent: PostContent
};

export default post;